// Default chart palette for the v2 layout — five distinct, harmonious
// primer hues. Combined with `ChartCardDefaultsContext.rotateBasePerChart`
// each ChartCard mounted under the provider draws a different primer
// color in round-robin order, and `monoShadePerCategory` derives shades
// of that primer for single-series bars / slices.
//
// Order matters — the first chart in the dashboard gets `[0]` (amber),
// the next `[1]` (blue), and so on. The order leads with the v2 accent
// so the most prominent first chart anchors visually.
//
// Note: kept as a standalone export rather than living on the MUI theme,
// because chart consumers iterate over the array (round-robin), and
// theme reads like `theme.palette.primary.main` only expose single
// values, not ordered sequences.

export const V2_CHART_PALETTE: readonly string[] = [
    '#e0a458', // amber (primary accent)
    '#7d9bd1', // muted blue
    '#9c8bb5', // muted lavender
    '#5eb88a', // green
    '#d97a7a', // coral
] as const;
